<template>
<!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Failed Post</div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="postAgain">Post</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="app-filter-good-table-container">
                  <div class="social-media-calendar bottom-employee-detail col-12 float-l" style="background-color: white;">
                      <div class="">
                          <h2 class="color-red heading-text-24 line-height-28 font-text-semi-medium-mont float-l width-full p-3"> {{selected.title}}
                              <!-- <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="buttonBack(0)"><i aria-hidden="true" class="fa fa-chevron-left"></i></button> -->
                              <button type="button" id="openModel" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal" style="display: none;">Open Modal</button>
                              <!--<template v-if="loginUserID == selected.created_by_id">-->
                              <!-- <button v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1" type="submit" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="editEvent(selected.id)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                              <button v-show="roleId <= 1 || userPermissions.indexOf('post_social_media') > -1 || userPermissions.indexOf('draft_social_media') > -1" type="submit" class="mr-1 btn btn-primary pull-right" v-on:click.prevent="deleteEvents(selected.id)"><i class="fa fa-trash" aria-hidden="true"></i></button> -->
                              <!--</template>-->
                          </h2>
                          <div class="">
                              <div class="bottom-employee-detail-left col-12 col-sm-6 col-md-6 col-lg-6">

                                  <div class="bg-color-table mt-20 float-l width-full">
                                      <div class="bus-detail-row width-full float-l">
                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Social Media  </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18">
                                              <template v-if="selected.media_type != null">
                                              {{ capitalizeFirstLetter(selected.media_type) }}
                                              </template>
                                              </p>
                                          </div>
                                      </div>
                                      <div class="bus-detail-row width-full float-l">
                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Contact Person </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18">
                                              {{ capitalizeFirstLetter(selected.contact_person)}}
                                              </p>
                                          </div>
                                      </div>

                                      <div class="bus-detail-row width-full float-l">


                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Companies To Share With </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18">
                                              {{selected.company}}
                                                </p>
                                          </div>
                                      </div>

                                      <div class="bus-detail-row width-full float-l">

                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Post Date </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18">
                                                {{ selected.start_date_time }}
                                              </p>
                                          </div>



                                      </div>
                                      <template v-if="selected.contact_number != ''">
                                          <div class="bus-detail-row width-full float-l">
                                              <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                                  <p class="small-bullet center"></p>
                                              </div>
                                              <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                                  <p class="color-333333 heading-text-14 line-height-18"> Contact Number </p>
                                              </div>
                                              <div class="col-inner-detail col-number colpie-60 float-l">
                                                  <p class="color-blue heading-text-14 line-height-18"> {{selected.contact_number}} </p>
                                              </div>
                                          </div>
                                      </template>
                                  </div>

                              </div>
                              <div class="bottom-employee-detail-right col-12 col-sm-6 col-md-6 col-lg-6">
                                  <div class="bg-color-table mt-20 float-l width-full">

                                      <div class="bus-detail-row width-full float-l">
                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Social Media Profile </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18"> {{selected.profile_name}} </p>
                                          </div>
                                      </div>

                                      <div class="bus-detail-row width-full float-l">
                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Contact Email </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18">
                                              {{selected.contact_email}}
                                              </p>
                                          </div>
                                      </div>

                                      <div class="bus-detail-row width-full float-l ">
                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Hash Tags </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18"> {{selected.has_tags}} </p>
                                          </div>
                                      </div>


                                      <div class="bus-detail-row width-full float-l ">
                                          <div class="col-inner-detail inner-first-row border-rt-white colpie-8 float-l">
                                              <p class="small-bullet center"></p>
                                          </div>
                                          <div class="col-inner-detail col-area border-rt-white colpie-32 float-l">
                                              <p class="color-333333 heading-text-14 line-height-18"> Failed Date </p>
                                          </div>
                                          <div class="col-inner-detail col-number colpie-60 float-l">
                                              <p class="color-blue heading-text-14 line-height-18"> {{selected.failed_date}} </p>
                                          </div>
                                      </div>

                                  </div>
                              </div>
                          </div>
                          <h2 class="mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"> Description </h2>
                          <div class="">
                              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                  <div class="social-media-description bg-color-table mt-20 mb-20 float-l width-full" v-html='selected.description'></div>
                              </div>
                          </div>


                          <h2 class="mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"> Error </h2>
                          <div class="">
                              <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                  <div class="social-media-description bg-color-table mt-20 mb-20 float-l width-full" v-html='selected.error'></div>
                              </div>
                          </div>


                          <template v-if="selectedAttachments > 0">
                              <h2 class="mt-14 heading-text-18 line-height-18 font-text-semi-medium-mont float-l width-full"> Attachments
                              <button type="button" id="DownloadAll" class="btn btn-primary pull-right" v-on:click.prevent="downloadAllAttachments(selected.id)">Download All</button></h2>
                              <div class="">
                                  <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                      <div class="social-media-description bg-color-table mt-20 mb-20 float-l width-full">
                                          <template>
                                              <swiper class="" :options="swiperOptionAttachments" ref="swiperAttachment">
                                                  <template v-for="(doc, index1) in selected.media">
                                                      <template v-if="doc.type.toLowerCase() == 'image'">
                                                          <swiper-slide>
                                                              <img :src="imageUrl(doc.document)" @click="openGallery(selected.media,index1)">
                                                          </swiper-slide>
                                                      </template>
                                                      <template v-else-if="doc.type.toLowerCase() == 'video'">
                                                          <swiper-slide>
                                                              <!--<a :href="doc.url" target="_blank" download><img src="/static/images/video-icon.png" class="link-icon"></a>-->
                                                              <img v-on:click="downloadImage(doc.document)" src="/static/images/video-icon.png" class="link-icon">
                                                          </swiper-slide>
                                                      </template>
                                                      <template v-else-if="doc.extension.toLowerCase() == 'doc' || doc.extension.toLowerCase() == 'docx'">
                                                          <swiper-slide>
                                                              <a :href="doc.url" target="_blank"><img src="/static/images/doc-icon.png" class="link-icon"></a>
                                                          </swiper-slide>
                                                      </template>
                                                      <template v-else-if="doc.extension.toLowerCase() == 'xls' || doc.extension.toLowerCase() == 'xlsx'">
                                                          <swiper-slide>
                                                              <a :href="doc.url" target="_blank"><img src="/static/images/xl-icon.png" class="link-icon"></a>
                                                          </swiper-slide>
                                                      </template>
                                                      <template v-else-if="doc.extension.toLowerCase() == 'ppt' || doc.extension.toLowerCase() == 'pptx'">
                                                          <swiper-slide>
                                                              <a :href="doc.url" target="_blank"><img src="/static/images/ppt-icon.png" class="link-icon"></a>
                                                          </swiper-slide>
                                                      </template>
                                                      <template v-else-if="doc.extension.toLowerCase() == 'pdf'">
                                                          <swiper-slide>
                                                              <a :href="doc.url" target="_blank"><img src="/static/images/pdf-icon.png" class="link-icon"></a>
                                                          </swiper-slide>
                                                      </template>
                                                      <template v-else>
                                                          <swiper-slide>
                                                              <a :href="doc.url" target="_blank"><img src="/static/images/link-icon.png" class="link-icon"></a>
                                                          </swiper-slide>
                                                      </template>
                                                  </template>
                                              </swiper>
                                          </template>
                                      </div>
                                  </div>
                              </div>
                          </template>
                          <!-- Modal -->
                          <div class="modal fade socialmediacalendarpopup" id="myModal" role="dialog">
                              <div class="modal-dialog modal-lg">
                                  <div class="modal-content">
                                      <div class="modal-body">
                                          <img class="w-100 mb-3" :src="viewImage">
                                      </div>
                                      <div class="modal-footer">

                                          <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('previous')"><i class="fa fa-angle-left" aria-hidden="true"></i></button>
                                          <button type="button" class="ml-2 btn btn-primary pull-right themebutton" v-on:click="changeImage('next')"><i class="fa fa-angle-right" aria-hidden="true"></i></button>
                                          <!--<a :href="viewImage" target="_blank" download="" class="ml-2 btn btn-primary pull-right themebutton">download</a>-->
                                          <button class="ml-2 btn btn-primary pull-right themebutton" type="button"  v-on:click="downloadZip(viewImage)"><i class="fa fa-download" aria-hidden="true"></i></button>
                                          <!--<span class="pull-right pt-10 mr-1">{{lightboxImages.length}} / {{(index+1)}}</span>-->
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

            </div>
            </div>
            <!--page content-->

        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>

  import Vue from 'vue';
  import BackendFooter from '@/components/backend/partials/Footer';
  import VueGoodTable from 'vue-good-table';
  import 'vue-good-table/dist/vue-good-table.css';
  Vue.use(VueGoodTable);
  import SessioMixin from '../../../mixins/sessionmixin';
  import { HTTP } from '../../../http-common';

  import 'swiper/dist/css/swiper.css';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

  var self;
export default {
  name: 'FailedPost',
  components: {
      'app-backend-footer': BackendFooter,
      swiper,
      swiperSlide,
  },
  mixins: [SessioMixin],
  data() {
    return {
      selected: {},
      selectedAttachments: 0,
      swiperOptionAttachments: {
          slidesPerView: 14.5,
          spaceBetween: 8,
          freeMode: true,
          pagination: {
              el: '.swiper-pagination',
              clickable: true
          },
          breakpoints: {
              1500: {
                  slidesPerView: 12.5
              },
              1400: {
                  slidesPerView: 11.5
              },
              1300: {
                  slidesPerView: 10.4
              },
              1200: {
                  slidesPerView: 8.5
              },
              1000: {
                  slidesPerView: 7.5
              },
              667: {
                  slidesPerView: 5.5
              },
              480: {
                  slidesPerView: 3.5
              },
              360: {
                  slidesPerView: 3.4
              }
          }
      },
      lightboxImages: [],
      viewImage: '',
      index: 0,
      swipViews: 0,
    }
  },
  beforeMount: function () {
      self = this;
      self.checkLogin();
  },
  mounted: function () {
    // $('#myModal').modal('toggle');
    self.getFailedPost()
  },
  methods: {
    postAgain() {
      console.log("POST AGAIN");
      var config = {
          headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
      };
      var fields = {
          ids: [this.$route.query.id],
      };
      self.showLoader();
      HTTP.post('socialmedia/post/failed', fields, config)
          .then(function (response) {
            console.log(response.data);
              if (response.data === "done") {
                self.$swal('Post', 'Post published successfully', 'success');
                setTimeout(function () {
                    self.buttonBack();
                }, 3000);
              }
              self.hideLoader();
          })
          .catch(function (err) {
            console.log("err =", err);
              if (err.response.status == 0) {
                  if (err.response.status == 0) {
                      self.error = "Remote server can not be reachable";
                  } else {
                      //redirect to login page if user not authenticated
                      if (err.response.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("api_token");
                          localStorage.removeItem("profile_image");
                          self.$router.push("/login");
                          //EventBus.$emit("logged-in", true, "", "");
                      }
                      self.error = err.response.data.message;
                  }
              }
              self.hideLoader();
          });


    },
    buttonBack() {
        $(".back_button").prop("disabled", false);
        self.$router.push('/backend/social/failed');
    },
    imageUrl(image) {
      // video/mp4
      return process.env.BUCKET_FILE_PREFIX + image;
      // "/api/" +
    },
    openGallery: function (documents, index) {
      console.log(documents);
        var self = this;
        var arr = [];
        var new_index = 0;
        $.each(documents, function (i) {
            if (documents[i].type.toLowerCase() == 'image') {
                if (i == index) {
                    index = new_index;
                }
                arr.push(self.imageUrl(documents[i].document));
                new_index = new_index + 1;
            }
        });
        self.loadImagesInLightBox(arr, index);
    },
    loadImagesInLightBox: function (arr, index) {
      console.log(arr);
        self.lightboxImages = arr;
        self.index = index;
        self.viewImage = self.lightboxImages[self.index];
        $('#openModel').click();
    },
    changeImage: function (move) {
        var self = this;
        if (move == 'next') {
            self.index = self.index + 1;
            if (self.lightboxImages.length <= self.index) {
                self.index = 0;
            }
        } else {
            self.index = self.index - 1;
            if (self.index < 0) {
                self.index = (self.lightboxImages.length - 1);
            }
        }
        self.viewImage = self.lightboxImages[self.index];
    },
    downloadImage: function (filepath) {
        window.open(process.env.BASE_URL + "/api/" + filepath, 'Download');
        //window.location.assign(self.viewImage);
        /*location.href = self.viewImage;*/
    },
    downloadZip: function (filepath) {
        window.open(filepath, 'Download');
        //window.location.assign(self.viewImage);
        /*location.href = self.viewImage;*/
    },
    getFailedPost: function () {
      // self.firstLoad = 1;
      // var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
      // if (newPage) {
      //     if (newPage < self.serverParams.page) {
      //         self.serverParams.page = newPage;
      //     }
      // }
      var config = {
          headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
      };
      var fields = {
          id: this.$route.query.id,
          // perPage: self.serverParams.perPage,
          // filters: self.serverParams.columnFilters,
          // messageData: self.message,
          // sort: self.serverParams.sort,
          // year: self.year
      };
      self.showLoader();
      HTTP.post('socialmedia/failed/post', fields, config)
          .then(function (response) {
            console.log(response);
              if (response.data.code == 200) {
                  self.selected = response.data.content;
                  self.selectedAttachments = self.selected.media.length;
                  console.log("TEST");
                  console.log(self.selectedAttachments);
              }
              self.hideLoader();
          })
          .catch(function (err) {
            console.log("err =", err);
              if (err.response.status == 0) {
                  if (err.response.status == 0) {
                      self.error = "Remote server can not be reachable";
                  } else {
                      //redirect to login page if user not authenticated
                      if (err.response.status == 401) {
                          //clear previous data
                          localStorage.removeItem("user_obj");
                          localStorage.removeItem("api_token");
                          localStorage.removeItem("profile_image");
                          self.$router.push("/login");
                          //EventBus.$emit("logged-in", true, "", "");
                      }
                      self.error = err.response.data.message;
                  }
              }
              self.hideLoader();
          });


    },
    downloadAllAttachments(id) {
        /*console.log(id);*/
        $("#DownloadAll").prop("disabled", true);
        $("#DownloadAll").html("Preparing File...");
        if (id) {
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                params: {id: id}
            };
            HTTP.get("downloadattachment", config)
                    .then(function (response) {
                        /*console.log(id);*/
                        self.downloadZip(response.data.content.zip_file);
                        $("#DownloadAll").prop("disabled", false);
                        $("#DownloadAll").html("Download All");
                    })
                    .catch(function (err) {
                        $("#DownloadAll").prop("disabled", false);
                        $("#DownloadAll").html("Download All");
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            } else {
                                self.$swal('Cancelled', err.response.data.message, 'info');
                                self.buttonBack(2);
                            }
                        }
                    });
        }
    },

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/backend/socialmedia/FailedPostDetail.vue